import JassEventId from './eventid';

/**
 * type widgetevent
 */
export default class JassWidgetEvent extends JassEventId {}
